import {
  
  ACTIVATING_GOOGLE_ANALYTICS_REQUEST, ACTIVATING_GOOGLE_ANALYTICS_SUCCEDDED, ACTIVATING_GOOGLE_ANALYTICS_FAILED,
  UPDATING_GOOGLE_ANALYTICS_REQUEST, UPDATING_GOOGLE_ANALYTICS_SUCCEDDED, UPDATING_GOOGLE_ANALYTICS_FAILED
} from '../actionTypes.jsx';
import {activatingIntegrationSuccedded } from '../integrations';
import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const GOOGLE_ANALYTICS_BASE_URL = `${apiUrl}/api/2.0/integrations/google-analytics`;

export function activateAccount(configuration){
  return function (dispatch) {
    dispatch(activatingAccount());

    return axios({
      method: 'POST',
      url: GOOGLE_ANALYTICS_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(activatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
      return response.data;
    })
    .catch(error =>
      dispatch(activatingAccountFailed(error.errors))
    )
  }
}

function activatingAccount(){
  return {
    type: ACTIVATING_GOOGLE_ANALYTICS_REQUEST,
    payload: {}
  }
}

function activatingAccountSuccedded(json){
  return {
    type: ACTIVATING_GOOGLE_ANALYTICS_SUCCEDDED,
    payload: json
  }
}

function activatingAccountFailed(error){
  return {
    type: ACTIVATING_GOOGLE_ANALYTICS_FAILED,
    payload: error
  }
}

/**
* Update google analytics configuration
*/
export function updateGoogleAnalyticsConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingGoogleAnalyticsConfiguration());

    return axios({
      method: 'PUT',
      url: GOOGLE_ANALYTICS_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingGoogleAnalyticsConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(updatingGoogleAnalyticsConfigurationFailed(error.errors))
    )
  }
}

function updatingGoogleAnalyticsConfiguration(){
  return {
    type: UPDATING_GOOGLE_ANALYTICS_REQUEST,
    payload: {}
  }
}

function updatingGoogleAnalyticsConfigurationSuccedded(json){
  return {
    type: UPDATING_GOOGLE_ANALYTICS_SUCCEDDED,
    payload: json
  }
}

function updatingGoogleAnalyticsConfigurationFailed(error){
  return {
    type: UPDATING_GOOGLE_ANALYTICS_FAILED,
    payload: error
  }
}
